export default "__VITE_ASSET__eOMbL9k8__"